import React, { useState } from "react";
import TableCliente from "../../clientes/TableCliente";
import Loader from "../../../components/ui/Loader";
import HeaderSteps from "../../../components/ui/Steps";
import DocumentoFilter from "../DocumentoFilter";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

const Factura = (props) => {
  const [loading, setLoading] = useState(false);
  const [rut, setRut] = useState("");
  const [codigo, setCodigo] = useState("");
  const [razonSocial, setRazonSocial] = useState("");
  const [tabla, setTabla] = useState();
  const navigate = useNavigate();

  const handleClear = () => {
    setRut("");
    setCodigo("");
    setRazonSocial("");
    setTabla(null);
  };

  return (

        <>
          {/* <div className="flex flex-column md:flex-row md:align-items-center md:justify-content-between"> */}
          <div className="flex flex-column md:flex-row md:align-items-center md:justify-content-between py-0">
              <div className="flex align-items-center">
                  <Button
                      type="button"
                      className="p-button-rounded p-button-text text-600 mr-2"
                      icon="pi pi-arrow-left"
                      onClick={() => navigate(`/tablero`)}
                      tooltip="Volver"
                  />
                  <h4 className="m-0 text-lg">Ingreso de Cotización Factura</h4>
              </div>
              <HeaderSteps activeIndex={0} />
          </div>
          <div className="grid p-fluid">
            <div className="col-12">
              <DocumentoFilter
                codigo={codigo}
                setCodigo={setCodigo}
                rut={rut}
                setRut={setRut}
                razonSocial={razonSocial}
                setRazonSocial={setRazonSocial}
                tipo="factura"
                setTabla={setTabla}
                setLoading={setLoading}
                onClear={handleClear}
                onNew={() => {}}
              />
            </div> 
            
            <div className="col-12">
              {loading ? (
                <>
                  <Loader></Loader>
                </>
              ) : (
                <TableCliente data={tabla} tipo="factura" />
              )}
            </div>
          </div>
        </>
  );
};

export default Factura;
